import { render, staticRenderFns } from "./GrListTab.vue?vue&type=template&id=a79ecb22&scoped=true"
import script from "./GrListTab.vue?vue&type=script&lang=js"
export * from "./GrListTab.vue?vue&type=script&lang=js"
import style0 from "./GrListTab.vue?vue&type=style&index=0&id=a79ecb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79ecb22",
  null
  
)

export default component.exports